<template>
    <v-app>
        <v-dialog v-model="dialog" max-width="800">
            <v-card>
                <v-toolbar dark>
                    <v-card-title class="headline">
                        Visitor summary
                        <hr>
                    </v-card-title>

                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="hideModal">
                            <i class="fas fa-times"></i>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="12" class="ml-2">
                            <div>
                                <h5>
                                    <strong> Category: </strong> {{ visitor.category }}
                                </h5>
                            </div>
                            
                            <div class="d-flex justify-space-between">
                                <h5 class="mt-3">
                                    <strong>Name: </strong> {{ visitor.first_name }} {{ visitor.last_name }}
                                </h5>
                                <h5 class="mr-1 mt-3">
                                    <strong>Phone: </strong> {{ visitor.phone ? visitor.phone : '-' }}
                                </h5>
                            </div>

                            <div class="d-flex justify-space-between">
                                <h5 class="mt-3">
                                    <strong>Email: </strong> {{ visitor.email ? visitor.email : '-'}}
                                </h5>
                                <h5 class="mt-3 mr-1">
                                    <strong>Address: </strong> {{ visitor.address ? visitor.address : '-'}}
                                </h5>
                            </div>
                            
                            
                            <div class="d-flex justify-space-between">
                                <h5 class="mt-3">
                                    <strong>Entry date: </strong> {{ visitor.formatted_entry_datetime ? visitor.formatted_entry_datetime : '-'}}
                                </h5>
                                <h5 class="mt-3 mr-1">
                                    <strong>Exit date: </strong> {{ visitor.formatted_exit_datetime ? visitor.formatted_exit_datetime : '-'}}
                                </h5>
                            </div>

                            <h5 class="mt-3 border p-3">
                                <strong>Description: </strong> 
                                <div class="mt-2" v-html="visitor.description"></div>
                            </h5>

                            <div class="d-flex">
                                <h5 class="mt-3">
                                    <strong>Contact point: </strong> {{ visitor.contact_point ? visitor.contact_point : '-'}}
                                </h5>
                                <h5 class="mt-3 ml-26" >
                                    <strong>Follow up required: </strong> {{ visitor.follow_up_required ? 'Yes' : '-'}}
                                </h5>
                                <h5 class="mt-3 ml-26" v-if="visitor.follow_up_required">
                                    <strong>Follow up date: </strong> {{ visitor.follow_up_date ? visitor.follow_up_date : '-'}}
                                </h5>
                            </div>

                            <div class="d-flex">
                                <h5 class="mt-3">
                                    <strong>Status: </strong> 
                                    <span class="badge badge-danger" v-if="visitor.entry_datetime && visitor.exit_datetime">
                                        Out
                                    </span>
                                    <span class="badge badge-success" v-if="visitor.entry_datetime && !visitor.exit_datetime">
                                        In
                                    </span>
                                </h5>
                                <h5 class="mt-3 ml-26" v-if="visitor.follow_up_required">
                                    <strong>Follow up required: </strong> {{ visitor.follow_up_required ? 'Yes' : '-'}}
                                </h5>
                            </div>

                            <h5 class="mt-3 border p-3">
                                <strong>Remarks: </strong> 
                                <div v-if="visitor.remarks" class="mt-2" v-html="visitor.remarks"></div>
                                <div v-if="!visitor.remarks" class="mt-2"> NA </div>
                            </h5>

                        </v-col>
                        <v-col cols="12">
                            <div class="text-right float-right">
                                <v-btn 
                                    depressed 
                                    @click="hideModal" 
                                    class="text-gray btn btn-standard
                                ">
                                    Close
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>

</template>
<script>
export default {
    data() {
        return {
            visitor: '',
            dialog: false
        };
    },
    methods: {
        showModal(visitor) {
            this.visitor = visitor;
            this.dialog = true;
        },
        hideModal() {
            this.dialog = false;
        }
    }
}
</script>
